import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './index.css';
import App from './App';
import Login from './pages/Login';
import LandingPage from './pages/LandingPage';
import ClientDashboard from './pages/client/ClientDashboard';
import { ClientAuthProvider } from './contexts/ClientAuthContext';

// Composant pour les routes protégées (application back-office)
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  console.log('ProtectedRoute - isAuthenticated:', isAuthenticated, 'loading:', loading);
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Composant pour rediriger si déjà connecté (staff)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/app" replace />;
  }
  
  return children;
};

// Composant pour les routes client protégées
const ClientProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('client_access_token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Composant principal avec les routes
const AppRoutes = () => {
  return (
    <Routes>
      {/* Route publique - Page d'accueil visible par tous */}
      <Route path="/" element={<LandingPage />} />
      
      {/* Route publique - Page de connexion staff */}
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      
      {/* Route protégée - Application back-office (staff) */}
      <Route path="/app" element={
        <ProtectedRoute>
          <App />
        </ProtectedRoute>
      } />
      
      {/* Route protégée - Dashboard client */}
      <Route path="/client/dashboard" element={
        <ClientProtectedRoute>
          <ClientAuthProvider>
            <ClientDashboard />
          </ClientAuthProvider>
        </ClientProtectedRoute>
      } />
      
      {/* Redirection pour les routes inconnues */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);